import axios from "@/utils/index";
import { encryptAES, deAesEcb } from "@/utils/aes.js";

class CommonApi {
    _deAesGis(res) {
        if (res.value) {
            if (res.value.receiverLatitude) {
                res.value.receiverLatitude = deAesEcb(
                    res.value.receiverLatitude
                );
                res.value.receiverLongitude = deAesEcb(
                    res.value.receiverLongitude
                );
            }
            if (res.value.senderLatitude) {
                res.value.senderLatitude = deAesEcb(res.value.senderLatitude);
                res.value.senderLongitude = deAesEcb(res.value.senderLongitude);
            }
        }
    }
    // 单个邮件详情查询
    queryTrack(obj, config) {
        obj.value[0].trackList = encryptAES(
            JSON.stringify(obj.value[0].trackList)
        );
        return axios
            .post("/cutPicEnglish/queryTrack", obj, config)
            .then((res) => {
                this._deAesGis(res);
                return res;
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }
    // 多个邮件详情查询
    mixedQuery(obj, config) {
        return axios
            .post("/ordermixed/query", obj, config)
            .then((res) => {
                this._deAesGis(res);
                return res;
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }

    checkcapcode(obj, config) {
        obj.value[0].trackList = encryptAES(
            JSON.stringify(obj.value[0].trackList)
        );
        return axios.post("/cutPic/checkcapcode", obj, config);
    }
    getLogisticsTestFlag(obj, config) {
        obj.value.trackList = encryptAES(JSON.stringify(obj.value.trackList));
        return axios.post("/trackTestQuery/getLogisticsTestFlag", obj, config);
    }
    getNotionTestMessage(obj, config) {
        obj.value.trackList = encryptAES(JSON.stringify(obj.value.trackList));
        return axios
            .post("/trackTestQuery/getNotionTestMessage", obj, config)
            .then((res) => {
                this._deAesGis(res);
                return res;
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }
    getCityName(obj) {
        return axios.post("/trackQuery/getCityName", obj);
    }
    getPictureNew() {
        return axios.post("/cutPic/getPictureNew");
    }
    checkcapcodeNew(obj) {
        return axios.post("/cutPic/checkcapcodeNew", obj);
    }
}

export default new CommonApi();
